import { jsx as _jsx } from "react/jsx-runtime";
import Markdown from 'markdown-to-jsx';
export default function PostBody(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/_jsx("div", {
    className: "max-w-5xl mx-auto prose lg:prose-xl",
    children: /*#__PURE__*/_jsx(Markdown, {
      options: {
        forceBlock: true
      },
      children: content
    })
  });
}